/*
Copyright 2026 Element Creations Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

import i18n from "i18next";

export class ClientInitializationTimeout extends Error {
  constructor(readonly stage: string) {
    super(i18n.t("instance.ui.session_restore_retry"));
  }
}
/** Stop the pipeline on a stalled browser store/worker/network operation. */
export async function initializationStep<T>(
  stage: string,
  action: Promise<T>,
  milliseconds = 30000,
): Promise<T> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    return await Promise.race([
      action,
      new Promise<never>((_, reject) => {
        timer = setTimeout(
          () => reject(new ClientInitializationTimeout(stage)),
          milliseconds,
        );
      }),
    ]);
  } finally {
    clearTimeout(timer);
  }
}
